import { StyleSheet } from "@react-pdf/renderer";

const standardBorder = "0.5px solid #A8A8A8";

export const styles = StyleSheet.create({
	document: {
		// fontFamily: "CustomFont",
		paddingTop: 35,
		paddingBottom: 65,
		paddingHorizontal: 20,
	},
	documentTight: {
		paddingTop: 16,
		paddingBottom: 16,
		paddingHorizontal: 12,
	},
	reportType: {
		marginBottom: 16,
		paddingTop: 4,
		paddingBottom: 4,
		paddingLeft: 8,
		fontSize: 12,
		borderLeft: "2px solid #00003C",
	},
	title: {
		fontSize: 14,
		textAlign: "center",
		fontWeight: "bold",
	},
	WETitle: {
		width: "75%",
		left: 0,
		top: 0,
		textAlign: "left",
		fontSize: 14,
		fontWeight: "bold",
	},
	logoImageContainer: {
		position: "absolute",
		right: 0,
		top: 0,
		display: "flex",
		flexDirection: "column",
		gap: 4,
		textAlign: "right",
		justifyContent: "flex-end",
		alignItems: "flex-end",
	},
	logo: {
		width: 97.5,
		height: 27,
		marginRight: 4,
	},
	tenantLogo: {
		width: 64,
		height: 64,
		objectFit: "contain",
	},
	email: {
		fontSize: 10,
		marginLeft: 4,
		color: "#A8A8A8",
	},
	section: {
		marginBottom: 15,
		borderBottom: standardBorder,
	},
	tableHeader: {
		fontSize: 12,
		padding: 8,
		fontWeight: "bold",
		backgroundColor: "#00003C",
		color: "#fff",
		border: "0.5px solid #00003C",
	},
	tableFontSize: {
		fontSize: 10,
	},
	row: {
		flexDirection: "row",
	},
	column: {
		flexDirection: "column",
	},
	QRSize: {
		width: 50,
		height: 50,
	},
	// New consolidated styles
	labelCell: {
		flex: 1,
		borderLeft: standardBorder,
		borderRight: standardBorder,
		borderTop: standardBorder,
		padding: 8,
		fontWeight: "bold",
	},
	labelLongCell: {
		flex: 1,
		borderLeft: standardBorder,
		borderRight: standardBorder,
		borderTop: standardBorder,
		padding: "4px 8px 4px 8px",
		fontWeight: "bold",
	},
	valueCell: {
		flex: 1,
		padding: 8,
		borderTop: standardBorder,
	},
	valueLongCell: {
		flex: 1,
		padding: "4px 8px 4px 8px",
		borderTop: standardBorder,
	},
	mergeCell: {
		flex: 1,
		padding: "4px 8px 4px 8px",
		borderLeft: standardBorder,
	},
	dayCell: {
		flex: 1,
		textAlign: "center",
		borderLeft: standardBorder,
		borderBottom: standardBorder,
		padding: 2,
	},
	hoursCell: {
		display: "flex",
		// justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
		width: 40,
		borderLeft: standardBorder,
		borderBottom: standardBorder,
		padding: 6,
	},
	daysCell: {
		display: "flex",
		alignItems: "center",
		textAlign: "center",
		width: 40,
		borderLeft: standardBorder,
		borderBottom: standardBorder,
		borderRight: standardBorder,
		padding: 6,
	},

	qrContainer: {
		width: "20%",
		borderLeft: standardBorder,
		alignItems: "center",
		justifyContent: "center",
		padding: 8,
		textAlign: "center",
	},
	emailContainer: {
		flexDirection: "row",
		alignItems: "center",
	},
	headerContainer: {
		marginBottom: 32,
	},
	borderLeft: {
		borderLeft: standardBorder,
	},
	borderRight: {
		borderRight: standardBorder,
	},
	borderBottom: {
		borderBottom: standardBorder,
	},
	borderTop: {
		borderTop: standardBorder,
	},
	headerFill: {
		backgroundColor: "#E9E9E9",
	},
	weekendCell: {
		backgroundColor: "#ABABAB",
		borderLeft: "0.5px solid #ABABAB",
		borderBottom: "0.5px solid #ABABAB",
	},
	naText: {
		fontStyle: "italic",
		color: "#A8A8A8",
	},
	tableHeaderRow: {
		flex: 1,
		fontWeight: "bold",
		backgroundColor: "#F2F2F2",
		padding: 8,
	},
});
